import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const styles = ({ spacing, typography }) => ({
  root: {
    width: '28%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    padding: `${spacing.unit * 1.5}px ${spacing.unit * 2}px 0 ${spacing.unit * 1.5}px !important`,
    marginBottom: spacing.unit * 2,
  },
  title: {
    fontSize: 'medium',
    fontFamily: typography.fontFamily,
    marginBottom: spacing.unit,
  },
  field: {
    float: 'left',
    height: '90px',
  },
  fieldContent: {
    width: '100%',
    marginRight: '0',
  },
});

const GroupedFields = ({ classes, fields = [], resource, record, title }) => (
  <SimpleShowLayout className={classes.root} resource={resource} record={record}>
    {title && (
      <Typography variant="subheading" className={classes.title}>
        {title}
      </Typography>
    )}
    {fields.map(field => field)}
  </SimpleShowLayout>
);

GroupedFields.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    title: PropTypes.string,
    field: PropTypes.string,
    fieldContent: PropTypes.string,
  }),
  fields: PropTypes.arrayOf(PropTypes.element),
  resource: PropTypes.string,
  record: PropTypes.shape({}),
  title: PropTypes.string,
};

export default withStyles(styles)(GroupedFields);
